import * as yup from 'yup';
import React, { MutableRefObject, useEffect } from 'react';
import { EHForm } from '@components';
import { FormikProps } from 'formik';
import { ElxMessageBarType } from '@elixir/components';
import { getErrorFromAxiosError, successMessage } from '@features';
import { AdminPageContext, IAdminPageContext } from '@pages/Admin';
import { useConfigureTemplate } from './hooks';
import { IConfigureTemplateFields } from '../hooks';
import { AdoForm } from '../adoForm';

const initialValues: IConfigureTemplateFields = {
  targetScope: '',
  reviewType: '',
  templateId: '',
  organizationId: '',
  projectId: '',
  workItemTypes: ['Task', 'Bug', 'Feature'],
  areaPath: '',
  isProcessExclusive: false,
};

const styles = {
  label: {
    fontWeight: 600,
  },
  form: {
    height: '100%',
  },
};

const schema = yup.object().shape({
  templateId: yup.string().required('Template Name is required'),
  targetScope: yup.string().required('Target Scope is required'),
  reviewType: yup.string().required('Review Type is required'),
  organizationId: yup.string().required('ADO Organization is required'),
  projectId: yup.string().required('ADO Project is required'),
  areaPath: yup.string().required('ADO WorkItemTypes is required'),
});

// eslint-disable-next-line max-lines-per-function
export const ConfigureTemplate = (): JSX.Element => {
  const { mutate: create, isLoading, error, isSuccess } = useConfigureTemplate();
  const { configureTemplate, ...adminCtx } = React.useContext<IAdminPageContext>(AdminPageContext);
  useEffect(() => adminCtx.setIsLoading(isLoading), [isLoading]);
  useEffect(() => {
    if (isSuccess) configureTemplate.setMessage(successMessage);
  }, [isSuccess]);
  useEffect(() => {
    if (error) {
      configureTemplate.setMessage({
        message: getErrorFromAxiosError(error),
        type: ElxMessageBarType.error,
      });
    } else configureTemplate.setMessage(undefined);
  }, [error]);

  return (
    <EHForm
      initialValues={initialValues}
      innerRef={
        configureTemplate.innerRef as MutableRefObject<FormikProps<IConfigureTemplateFields> | null>
      }
      onSubmit={(values): void => create(values)}
      style={styles.form}
      validationSchema={schema}>
      {(): JSX.Element => {
        return (
          <>
            <AdoForm isConfigureTemplate={true} />
          </>
        );
      }}
    </EHForm>
  );
};
